import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/stoprule_hourglass.png'
import _imports_1 from '../../assets/stoprule_handup.png'
import _imports_2 from '../../assets/stoprule_warrning.png'
import _imports_3 from '../../assets/stoprule_stoprule_limit4point.png'
import _imports_4 from '../../assets/stoprule_stoprule_5point.png'


const _hoisted_1 = { class: "container py-5 fs-4" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "bg-white rounded shadow p-5 text-center" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]

import { reactive } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SuspensionInstructions',
  setup(__props) {

const cancelTimelineImages = reactive({
  def: require("../../assets/stoprule_cancel_timeline.png"),
  sm: require("../../assets/stoprule_cancel_timeline_straight.png"),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<section class=\"mb-5\" data-v-d62af76e><h2 class=\"mb-3\" data-v-d62af76e>預約方法&amp;注意事項</h2><div class=\"precautions row row-cols-1 row-cols-xl-3 g-3\" data-v-d62af76e><div class=\"col\" data-v-d62af76e><div class=\"precautions-item bg-white rounded h-100 shadow\" data-v-d62af76e><div class=\"precautions-item-icon\" data-v-d62af76e><img src=\"" + _imports_0 + "\" alt=\"hourglass\" data-v-d62af76e></div><div class=\"precautions-item-content\" data-v-d62af76e><p data-v-d62af76e><span class=\"hightlight\" data-v-d62af76e>最多等待10分鐘</span>若遇早到、遲到請用APP或電話聯繫車隊</p></div></div></div><div class=\"col\" data-v-d62af76e><div class=\"precautions-item bg-white rounded h-100 shadow\" data-v-d62af76e><div class=\"precautions-item-icon\" data-v-d62af76e><img src=\"" + _imports_1 + "\" alt=\"hourglass\" data-v-d62af76e></div><div class=\"precautions-item-content\" data-v-d62af76e><p data-v-d62af76e>司機視以下狀況可<span class=\"hightlight\" data-v-d62af76e>拒載</span>：</p><ol class=\"fs-5\" data-v-d62af76e><li data-v-d62af76e>身患法定傳染病</li><li data-v-d62af76e>6歲以下兒童且無陪同者</li><li data-v-d62af76e>精神狀況不穩定 (飲酒、吸毒)</li><li data-v-d62af76e>攜帶違禁品、危險品、易生變壞或破損之物品</li><li data-v-d62af76e>未關籠之寵物，除輔助犬</li></ol></div></div></div><div class=\"col\" data-v-d62af76e><div class=\"precautions-item bg-white rounded h-100 shadow\" data-v-d62af76e><div class=\"precautions-item-icon\" data-v-d62af76e><img src=\"" + _imports_2 + "\" alt=\"hourglass\" data-v-d62af76e></div><div class=\"precautions-item-content\" data-v-d62af76e><p data-v-d62af76e> 讓大家有車坐若要取消預約請您務必留意<span class=\"hightlight\" data-v-d62af76e>取消規則</span></p></div></div></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "mb-3" }, "取消規則", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "d-inline-block text-start",
          style: {"max-width":"530px"}
        }, [
          _createElementVNode("p", { class: "mb-5" }, "為提升派車效率、維持服務水準、避免浪費資源，愛接送訂定取消車輛的記點規則，還請大家配合！")
        ], -1)),
        _createElementVNode("picture", null, [
          _createElementVNode("source", {
            srcset: cancelTimelineImages.def,
            media: "(min-width: 992px)"
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            class: "img-fluid",
            src: cancelTimelineImages.sm,
            alt: "計點規則說明圖"
          }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<section data-v-d62af76e><h2 class=\"mb-3\" data-v-d62af76e>停權說明</h2><div class=\"row row-cols-1 row-cols-xl-2 g-3\" data-v-d62af76e><div class=\"col\" data-v-d62af76e><div class=\"item-style bg-white rounded shadow\" data-v-d62af76e><img class=\"img-fluid mb-4\" src=\"" + _imports_3 + "\" alt=\"小於四點規則說明圖\" data-v-d62af76e><div class=\"content text-start\" data-v-d62af76e><p data-v-d62af76e>累計1~4 點，30 日內未再被登記點數，點數歸零</p></div></div></div><div class=\"col\" data-v-d62af76e><div class=\"item-style bg-white rounded shadow\" data-v-d62af76e><img class=\"img-fluid mb-4\" src=\"" + _imports_4 + "\" alt=\"大於等於五點規則說明圖\" data-v-d62af76e><div class=\"content text-start\" data-v-d62af76e><p data-v-d62af76e>累計至 5 點，停權使用 45 天後，點數歸零</p></div></div></div></div></section>", 1))
  ]))
}
}

})